/*
 * Application Insights JavaScript SDK - Common, 2.6.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


import { __extendsFn } from "@microsoft/applicationinsights-shims";
// THIS FILE WAS AUTOGENERATED
import { Base } from './Base';
/**
 * Data struct to contain both B and C sections.
 */
var Data = /** @class */ (function (_super) {
    __extendsFn(Data, _super);
    function Data() {
        return _super.call(this) || this;
    }
    return Data;
}(Base));
export { Data };
//# sourceMappingURL=Data.js.map